/** Truly generic things go here */

/**
 * Executes the first argument if it's a function and uses all remaining
 * arguments as, well, arguments. Else, returns the first argument
 */
export const execIfFn = (fn?: any, ...args: any[]) => (typeof fn === "function" ? fn(...args) : fn);

/**
 * Gets the first defined argument in a list of arguments
 */
export const getFirstDefined = (...args: any[]) => {
  for (let i = 0; i < args.length; i++) {
    if (typeof args[i] !== "undefined") {
      return args[i];
    }
  }

  return null;
};

export const EMDASH = "—";

export const enumKeys = <E>(e: E): (keyof E)[] => {
  return Object.keys(e) as (keyof E)[];
};
